import { DEVICE_FINANCE_STATUS } from 'invision-core/src/constants/status.constants';
export var deviceFinancingImage = function deviceFinancingImage(device) {
  var _ref = device || {},
    SubscriberInventory = _ref.SubscriberInventory;
  var _ref2 = SubscriberInventory || {},
    ImageUrl = _ref2.ImageUrl;
  return ImageUrl;
};
export var isDeviceFinanceCoolingOffStatus = function isDeviceFinanceCoolingOffStatus(device) {
  var _ref3 = device || {},
    Status = _ref3.Status;
  return DEVICE_FINANCE_STATUS.COOLING_OFF === Status;
};
export var deviceFinancingFriendlyName = function deviceFinancingFriendlyName(device) {
  var _ref4 = device || {},
    DeviceFinanceAccountNumber = _ref4.DeviceFinanceAccountNumber,
    ServiceIdentifier = _ref4.ServiceIdentifier,
    SerialNumber = _ref4.SerialNumber,
    SubscriberInventory = _ref4.SubscriberInventory;
  var _ref5 = SubscriberInventory || {},
    FriendlyName = _ref5.FriendlyName;
  var _ref6 = ServiceIdentifier || {},
    serviceFriendlyName = _ref6.FriendlyName,
    serviceValue = _ref6.Value;
  return FriendlyName || SerialNumber || serviceFriendlyName || serviceValue || DeviceFinanceAccountNumber;
};